import { render, staticRenderFns } from "./scheduler-deleting.vue?vue&type=template&id=1013d8c1&"
import script from "./scheduler-deleting.vue?vue&type=script&lang=ts&"
export * from "./scheduler-deleting.vue?vue&type=script&lang=ts&"
import style0 from "./scheduler-deleting.vue?vue&type=style&index=0&id=1013d8c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports